const Const = {
    RIGHT_MENU_IS_ACTIVE: 'RIGHT_MENU_IS_ACTIVE',
};

export default Const;